export default class AST {
  static Program = 'Program';
  static LogicalExpression = 'LogicalExpression';
  static UnaryExpression = 'UnaryExpression';
  static Query = 'Query';

  constructor(lexer) {
    this.lexer = lexer;
  }

  ast(text) {
    this.tokens = this.lexer.lex(text);
    return this.program();
  }

  program() {
    return { type: AST.Program, body: this.logicalOR() };
  }

  logicalOR() {
    let left = this.logicalAND();
    let token;
    while ((token = this.expect('|'))) {
      left = {
        type: AST.LogicalExpression,
        left: left,
        operator: token.value,
        right: this.logicalAND(),
      };
    }
    return left;
  }

  logicalAND() {
    let left = this.unary();
    let token;
    while ((token = this.expect('&'))) {
      left = {
        type: AST.LogicalExpression,
        left: left,
        operator: token.value,
        right: this.unary(),
      };
    }
    return left;
  }

  unary() {
    let token;
    /* eslint-disable-next-line */
    if ((token = this.expect('^'))) {
      return {
        type: AST.UnaryExpression,
        operator: '!',
        argument: this.primary(),
      };
    } else {
      return this.primary();
    }
  }

  primary() {
    let primary;

    if (this.expect('(')) {
      primary = this.logicalOR();
      this.consume(')');
    } else {
      primary = this.query();
    }
    return primary;
  }

  query() {
    return { type: AST.Query, value: this.consume().value };
  }

  consume(...args) {
    const token = this.expect(...args);
    if (!token) {
      /* eslint-disable-next-line */
      throw 'Unexpected. Expecting: ' + args[0];
    }
    return token;
  }

  expect(...args) {
    const token = this.peek(...args);
    if (token) {
      return this.tokens.shift();
    }
  }

  peek(...args) {
    if (this.tokens.length) {
      const value = this.tokens[0].value;
      if (args.includes(value) || !args.length) {
        return this.tokens[0];
      }
    }
  }
}
